const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate allKeysBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined || !isPlainObject(object)) {
    return undefined;
  }
  return Object.keys(object);
};
module.exports = {
  evaluate
};